import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Governance award section for selections tab
 */
const GovernanceAwardSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-bl-lg rounded-br-lg bg-gray-150"
      data-testid="governance-award-section-component"
    >
      <AccordionV2
        testId="governance-award"
        className="rounded-bl-lg rounded-br-lg border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Distinguished Contribution to Corporate Governance Award" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            This special one-off award was introduced in 2015 for the 10th
            anniversary of the Singapore Corporate Awards.
          </p>

          <p>
            In February 2015, nominations were called for the Distinguished
            Contribution to Corporate Governance Award along with the call for
            nominations of the other Singapore Corporate Award categories.
          </p>

          <p>
            The judges reviewed the nominations and concluded on one nominee
            which they felt stood out among all others – Mr. JY Pillay.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default GovernanceAwardSection;
